import { useState } from "react";
import { toast } from "sonner";
import { useLanguage, CONTACTS } from "../i18n";

export const Footer = () => {
  const { t } = useLanguage();
  const [email, setEmail] = useState("");

  const subscribe = (e) => {
    e.preventDefault();
    if (!email.includes("@")) return;
    toast.success(t.footer.newsletterSuccess);
    setEmail("");
  };

  return (
    <footer
      data-testid="restaurant-footer"
      className="relative grain"
      style={{ backgroundColor: "#1F0A12" }}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 pt-20 pb-28 md:pb-12">
        <div className="flex flex-col items-center text-center">
          <div className="w-44 sm:w-56 overflow-hidden">
            <img src="/logo-wordmark.png" alt="Sant'Irene" className="w-full h-auto" />
          </div>
          <p className="mt-5 font-display italic text-lg text-[#CBB9B0] max-w-md">
            {t.footer.tagline}
          </p>
        </div>

        <div className="mt-14 grid sm:grid-cols-3 gap-10 text-center sm:text-left">
          <div>
            <p className="font-meta text-[10px] uppercase tracking-[0.3em] text-[#C69255]">
              Sant'Irene
            </p>
            <p className="mt-4 text-sm text-[#CBB9B0] leading-relaxed">
              {CONTACTS.address}
              <br />
              {CONTACTS.phoneLabel}
              <br />
              <a href={`mailto:${CONTACTS.email}`} className="hover:text-[#C69255] transition-colors">
                {CONTACTS.email}
              </a>
            </p>
          </div>
          <div className="sm:text-center">
            <p className="font-meta text-[10px] uppercase tracking-[0.3em] text-[#C69255]">
              Social
            </p>
            <p className="mt-4 text-sm">
              <a
                data-testid="footer-instagram-link"
                href={CONTACTS.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#CBB9B0] hover:text-[#C69255] transition-colors"
              >
                Instagram — @{CONTACTS.instagram}
              </a>
            </p>
          </div>
          <div className="sm:text-right">
            <p className="font-meta text-[10px] uppercase tracking-[0.3em] text-[#C69255]">
              {t.footer.newsletterTitle}
            </p>
            <form data-testid="newsletter-form" onSubmit={subscribe} className="mt-4 flex justify-center sm:justify-end">
              <input
                data-testid="newsletter-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t.footer.newsletterPlaceholder}
                className="bg-transparent border-b border-[#C69255]/35 focus:border-[#C69255] outline-none text-sm text-[#F5EFE6] placeholder:text-[#CBB9B0]/50 py-2 w-44 transition-colors"
              />
              <button
                data-testid="newsletter-submit-btn"
                type="submit"
                className="ml-3 font-meta text-[10px] uppercase tracking-[0.2em] text-[#C69255] hover:text-[#D9AB72] transition-colors"
              >
                {t.footer.newsletterBtn}
              </button>
            </form>
          </div>
        </div>

        <div className="mt-14 pt-7 border-t border-[#C69255]/12 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-meta text-[10px] uppercase tracking-[0.18em] text-[#CBB9B0]/50">
            © 2026 Sant'Irene · {t.footer.vat} · {t.footer.rights}
          </p>
          <div className="flex gap-6">
            <a href="#" data-testid="footer-privacy-link" className="font-meta text-[10px] uppercase tracking-[0.18em] text-[#CBB9B0]/50 hover:text-[#C69255] transition-colors">
              {t.footer.privacy}
            </a>
            <a href="#" data-testid="footer-cookies-link" className="font-meta text-[10px] uppercase tracking-[0.18em] text-[#CBB9B0]/50 hover:text-[#C69255] transition-colors">
              {t.footer.cookies}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
